import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../../app/stores/store';
import { Menu } from 'semantic-ui-react';
import NFAIDAilyReport from './NFAIDAilyReport';
import NFAITimeSheet from './NFAITimeSheet'
import NFAIProductivityReport from './NFAIProductivityReport';
import NFAITimeSheetTaskAllocation from './NFAITimeSheetTaskAllocation';
import agent from '../../../../app/api/agent';
import NFAITimeSheetMastering from './NFAITimeSheetWorkflow';

const NFAITimeSheetProcess = () => {
  const { commonStore, userStore: {user} } = useStore();
  const isUserAuthorized =  
  // user?.displayName === 'R1387' ||  user?.displayName === 'R4456' || 
  user?.displayName === 'Mohamed Ehagaya' || user?.displayName === 'E1709' || user?.displayName === "R3077"  || user?.displayName === "R4456" || user?.displayName === "R1387";
  const initialSelected = isUserAuthorized ?  "Allocation":  "Timesheet";
  const [selected, setSelected] = useState(initialSelected);
  const [projectList, setProjectList] = useState<{ id: string; name: string; value: string }[]>([]);
  const [titleLoader, settitleLoader] = useState<boolean>(false);

   useEffect(() => {
    const fetchProjectList = async () => {
      try {
        settitleLoader(true);
        const { data: list } = await agent.NFAIRestoTimeSheet.getProjectList();
        const loadProjectList = list.map((item: any) => ({
          id: item.id,
          name: item.name,
          value: item.name,
        }));
        setProjectList(loadProjectList);
        settitleLoader(false);
      } catch (error) {
        settitleLoader(false);
        console.error("Error fetching project list:", error);
      }
    };

    fetchProjectList();
  }, []);

const data = [
  ...(isUserAuthorized ? ['Allocation'] : []),
  'Timesheet',
  'Report',
  ...(isUserAuthorized ? ['Productivity Report'] : []),
];

  const buttonStyle = { height: '10px' };
  const menuWrapperStyle = { padding: '5px', height: '47px' };
  const flexContainerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    flexWrap: 'wrap'
  };


  return (
    <div style={selected === 'Productivity Report' ? { height: '900px', padding: '0px 20px' } : { padding: '0px 20px' }}>
      <div className="newProductionPlanning-wrapper" style={{ width: '98%', margin: 'auto' }}>
        {!commonStore.RestorationCustomer && (
          <Menu style={menuWrapperStyle}>
            <div style={flexContainerStyle}>
              {data.map((element) => (
                      <button
                      style={buttonStyle}
                        className={ selected === element  ? 'selected' : ''  }
                        onClick={() => {
                          setSelected(element)
                        }}
                      >{element}</button>
              ))}
            </div>
          </Menu>
        )}
      </div>
      {selected === 'Timesheet' ? (user?.departmentName === "Mastering" || isUserAuthorized ? 
      <NFAITimeSheetMastering titleLoader={titleLoader} projectList={projectList} isUserAuthorized={isUserAuthorized}/> 
      : <NFAITimeSheet />) : selected === 'Report' ? (<NFAIDAilyReport  titleLoader={titleLoader} projectList={projectList}/>) 
      : selected === 'Productivity Report' ? (<NFAIProductivityReport titleLoader={titleLoader} projectList={projectList}/>) : selected === "Allocation" 
      ? (<NFAITimeSheetTaskAllocation  titleLoader={titleLoader} projectList={projectList}/>): null}
    </div>
  );
};

export default observer(NFAITimeSheetProcess);
